import { useGetOpenBetsSummaryQuery } from '@/store/api/betApi';
import { Link } from 'react-router-dom';
import Modal from '@/components/common/Modal';

type ExposureSummaryModalProps = {
  open: boolean;
  onClose: () => void;
};

const ExposureSummaryModal = ({ open, onClose }: ExposureSummaryModalProps) => {
  const { data, isFetching, isError } = useGetOpenBetsSummaryQuery(undefined, { skip: !open });
  const bets = data?.bets ?? [];

  // The summary API has no sport field; using the route param broke on non-sport pages,
  // so this stays static for now.
  const sportName = 'Cricket';

  const message = isFetching
    ? 'Loading open bets...'
    : isError
      ? 'Unable to load open bets summary.'
      : !bets.length
        ? 'No open bets found.'
        : null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="My Market"
      description="Markets where you currently have open bets"
      size="lg"
      bodyClassName=""
    >
      <div className="grid grid-cols-[1fr_1.4fr_1.2fr_56px] gap-2 bg-shell px-5 py-2 text-xs font-medium text-shell-muted">
        <span>Event Type</span>
        <span>Event Name</span>
        <span>Market</span>
        <span className="text-right">Bets</span>
      </div>

      {message ? (
        <p
          className={`px-5 py-10 text-center text-sm ${isError ? 'text-danger-red' : 'text-shell-muted'}`}
        >
          {message}
        </p>
      ) : (
        bets.map((bet) => (
          <div
            key={`${bet.eventId}-${bet.marketId}`}
            className="grid grid-cols-[1fr_1.4fr_1.2fr_56px] items-center gap-2 border-t border-shell-border px-5 py-3 text-sm"
          >
            <span className="truncate text-shell-muted">{sportName}</span>
            <Link
              to={`/game-details/${sportName}/${bet.eventId}`}
              onClick={onClose}
              className="truncate font-medium text-gold hover:underline"
            >
              {bet.eventName}
            </Link>
            <span className="truncate text-shell-fg">{bet.marketName}</span>
            <span className="text-right font-semibold text-shell-fg">{bet.betCount}</span>
          </div>
        ))
      )}
    </Modal>
  );
};

export default ExposureSummaryModal;
